export const ArrowUpRight = ({
  width = '16',
  height = '16',
  color = 'currentColor',
}: {
  width?: string;
  height?: string;
  color?: string;
}) => (
  <svg height={height} viewBox="0 0 16 16" width={width} xmlns="http://www.w3.org/2000/svg">
    <title />
    <g id="Complete">
      <g id="arrow-up-right">
        <g>
          <polyline
            data-name="Right"
            fill="none"
            id="Right-2"
            points="13 10 13 3 6 3"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <line
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            x1="3"
            x2="13"
            y1="13"
            y2="3"
          />
        </g>
      </g>
    </g>
  </svg>
);
